import { render, staticRenderFns } from "./PersonaRejoChecador.vue?vue&type=template&id=225a6d4f&"
import script from "./PersonaRejoChecador.vue?vue&type=script&lang=js&"
export * from "./PersonaRejoChecador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports